<script>
import resources from './resources'

export default {
  name: 'professional-specialitions-index',
  mixins: [resources]
}
</script>

<template lang="pug">
  page(title="Minhas Especializações", icon="")
    .col-xs-12.content
      .container-fluid
        .row
          .nav-tabs-wrapper
            ul.nav.nav-tabs.nav-340
              li.active
                a(href='#') Listagem
              li
                router-link(:to="{ name: 'professional.curriculum.specializations.create'  }")
                  a(href="#") Cadastro

          .col-xs-12.white-bg.wrapper(v-if="loading")
            .row.border-bottom-light
              spinner(:show="true")

          .col-xs-12.white-bg.wrapper(v-if="!loading")
            card-add(label='Nova<br>Especialização', route='professional.curriculum.specializations.create', icon='')
            .list-item.white-bg.list-item(v-for="specialization in specializations")
              .row.border-bottom
                h4.col-xs-7 {{ specialization.type_specialization.label }}
                .col-xs-5
                  .exclude-list(@click.prevent="doDelete(specialization)")
                    span.icon 
                  router-link(:to="{name: getRouterEdit, params: {id: specialization.id}}")
                    a(href='#')
                      .edit-list
                        span.icon 
              .list-info
                | {{ specialization.area }}
                br
                | {{ specialization.specialities.name}}
                br
                | {{ specialization.entity_name }}
            .pagination
              pagination(:pagination="pagination", @pagination-changed-page="setPage")
</template>



// WEBPACK FOOTER //
// src/app/professional/curriculum/specializations/index/index.vue